export default __webpack_public_path__ + "static/realWorldImg3-9fc6796190cb7198cd63b4580dd7c381.webp";